import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Faq extends Component {
  render() {
    return (
      <main id="faq">
        <h1 className="mb4 mt4">FAQ</h1>
        <h3>What types of things can I post?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          See&#160;
          <Link to="/guidelines" className="underline link">
            guidelines
          </Link>
          .
        </p>
        <h3>What types of things can’t I post?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          See&#160;
          <Link to="/guidelines" className="underline link">
            guidelines
          </Link>
          .
        </p>
        <h3>What kind of formatting can be used in comments?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          <p>Blank lines create separate paragraphs.</p>
          <p>
            Text surrounded by asterisks is italicized (if the character after
            the first asterisk isn't a space).
          </p>
          <p>
            To create a code block, add a blank line and indent text by two or
            more spaces.
          </p>
          <p>URLs become links.</p>
        </p>
        <h3>How are posts ranked?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Generally speaking, comments and posts are ranked according to the
          number of upvotes divided by the time since they were submitted.
        </p>
        <h3>How is a user’s karma calculated?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          A user’s karma is roughly equal to the number of upvotes on their
          stories and comments minus the number of downvotes.
        </p>
        <h3>How can I downvote something?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          There are no downvotes on posts. Once you reach a certain karma
          threshold, you can downvote comments.
        </p>
        <h3>How do I submit a question?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Just submit a post like you would normally, but don’t include a link.
        </p>
        <h3>Are reposts ok?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Only after an extended period of time, and only if the story hasn’t
          received much attention in the past 1-2 years. Otherwise, reposts will
          be flagged as duplicates.
        </p>
        <h3>Are paywalls ok?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Only if there are obvious workarounds so that people can still access
          the content.
        </p>
        <h3>Can I ask people to upvote my submission?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          No. We monitor and penalize this behavior. Submissions should gain
          attention organically because they’re inherently interesting to the
          community.
        </p>
        <h3>Can I ask people to comment on my submission?</h3>
        <p className="mb4 f10pt fw2 lh-p">No. Same as above.</p>
        <h3>How do I reset my password?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          If you have an email address in your profile, request a password reset{' '}
          <a href="/forgotpassword">here</a>. If you don’t, email{' '}
          <a href="mailto:hello@mln.dev" className="no-underline link">
            hello@mln.dev
          </a>{' '}
          for help.
        </p>
        <h3>Do you have an RSS feed?</h3>
        <p className="mb4 f10pt fw2 lh-p">
          Yes. Just go to{' '}
          <a href="mln.dev/rss" className="no-underline link">
            mln.dev/rss
          </a>{' '}
          from any RSS client.
        </p>
      </main>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/components/Faq.js